class SpielzeitLogoKlein extends HTMLElement {
    async connectedCallback() {
        this.showSpielzeitLogoInHeader();
    }

    showSpielzeitLogoInHeader() {
        const header = document.querySelector("header-prime");
        if (header) {
            header.showSpielzeitLogoLasche();
        }
    }

}

if (!customElements.get('spielzeit-logo-klein')) {
    customElements.define('spielzeit-logo-klein', SpielzeitLogoKlein);
}
